import { useState } from "react";
import { Menu } from "lucide-react";
import { getImageUri } from "../core/utils/imageLoad";

// Hooks
import { useCategories } from "../hooks/category";

// Tipos
import type { SidebarProps } from "../core/types/tsx/components/SideBar.types";

export function Sidebar({ selectedCategory, onSelect }: SidebarProps) {
	const [collapsed, setCollapsed] = useState(true);

	// 1. Usamos el hook refactorizado
	// El hook ya maneja el estado de carga y errores internamente
	const { data: categoriesData } = useCategories();

	// Aseguramos que sea un array
	const categories = categoriesData || [];

	// Helper para resolver la URL del icono
	const resolveIconUrl = (iconPath?: string) => {
		return getImageUri(iconPath) ?? null;
	};

	return (
		<aside
			className={`${collapsed ? "w-16 p-2" : "w-64 p-4"} border-r border-slate-300 bg-[#fcfcfc] transition-[width,padding] duration-300 ease-in-out`}
		>
			<nav className='flex flex-col gap-4 text-slate-900'>
				<div className='flex items-center justify-left'>
					<button
						type='button'
						aria-expanded={!collapsed}
						onClick={() => setCollapsed((prev) => !prev)}
						aria-label={collapsed ? "Abrir filtros" : "Cerrar filtros"}
						className='flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-700 shadow-sm transition-colors hover:bg-slate-100 focus:outline-none cursor-pointer'
					>
						<Menu className='h-4 w-4' />
					</button>
				</div>

				<ul className='flex flex-col gap-1 text-sm'>
					{/* 2. Mapeamos directamente sobre la respuesta plana del hook */}
					{categories.map((category) => {
						// Ya no necesitamos acceder a .attributes, los datos están en la raíz del objeto
						const { id, name_category, icon_category } = category;
						const active = name_category === selectedCategory;
						const iconSrc = resolveIconUrl(icon_category);

						return (
							<li key={id}>
								<button
									type='button'
									aria-label={name_category}
									aria-pressed={active}
									onClick={() => onSelect(name_category)}
									className={`${collapsed ? "flex justify-center" : "flex items-center gap-2 justify-start"} w-full cursor-pointer rounded-xl px-3 py-2 font-medium transition-colors ${
										active
											? "bg-primary text-white shadow-sm"
											: "text-slate-800 hover:bg-slate-100"
									}`}
								>
									{iconSrc && (
										<img
											src={iconSrc}
											alt={name_category}
											className='h-8 w-8 object-contain'
										/>
									)}
									<span
										className={`ml-2 min-w-0 flex-1 whitespace-nowrap text-left transition-all duration-300 ease-in-out ${
											collapsed
												? "opacity-0 max-w-0 w-0 overflow-hidden delay-0"
												: "opacity-100 max-w-full w-auto delay-75"
										}`}
									>
										{name_category}
									</span>
								</button>
							</li>
						);
					})}
				</ul>
			</nav>
		</aside>
	);
}
